import { useLocation, useNavigate } from 'react-router-dom';
import { useMe } from '../hooks/useMe';

type AdminTab = {
  key: string;
  label: string;
  short: string;
  active: boolean;
  path: string;
};

export function AppTabs() {
  const location = useLocation();
  const navigate = useNavigate();
  const me = useMe();

  const isCatalog = location.pathname.startsWith('/products')
    || location.pathname === '/';
  const isStudio = location.pathname.startsWith('/generations')
    || location.pathname.startsWith('/import');
  const isStats = location.pathname.startsWith('/stats');
  const isSettings = location.pathname.startsWith('/settings')
    || location.pathname.startsWith('/subscription');
  const isOwner = location.pathname.startsWith('/owner');
  const showOwner = me.data?.isOwner === true;

  const tabs: AdminTab[] = [
    { key: 'catalog', label: 'Каталог', short: 'Кат.', active: isCatalog, path: '/products' },
    { key: 'studio', label: 'Студия', short: 'Студ.', active: isStudio, path: '/generations' },
    { key: 'stats', label: 'Статистика', short: 'Стат.', active: isStats, path: '/stats' },
    { key: 'settings', label: 'Настройки', short: 'Настр.', active: isSettings, path: '/settings' },
  ];

  if (showOwner) tabs.push({ key: 'owner', label: 'Платформа', short: 'Плат.', active: isOwner, path: '/owner' });

  return (
    <nav className="admin-tabs" aria-label="Разделы кабинета">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          type="button"
          className={`admin-tabs__item${tab.active ? ' admin-tabs__item--active' : ''}`}
          aria-current={tab.active ? 'page' : undefined}
          title={tab.label}
          onClick={() => navigate(tab.path)}
        >
          <span className="admin-tabs__full">{tab.label}</span>
          <span className="admin-tabs__short">{tab.short}</span>
        </button>
      ))}
    </nav>
  );
}
